import React from 'react';
import DataSourcesPage from './DataSourcesPage';

const AnimalTypesPage: React.FC = () => (
  <DataSourcesPage
    title="Animal Types"
    itemLabel="Animal Type"
    addButtonLabel="Add Animal Type"
    source="ANIMAL TYPE"
    columns={[
      { key: 'code', label: 'SP Code' },
      { key: 'name', label: 'Species' }
    ]}
    fields={[
      { key: 'code', label: 'SP Code', required: true },
      { key: 'name', label: 'Species', required: true }
    ]}
  />
);

export default AnimalTypesPage;
